// src/App.js

import React, { useState, useRef } from 'react';
import ProjectIntro     from './ProjectIntro';
import RoomForm         from './RoomForm';
import { saveProjectToDisk, loadProjectFromFile } from './utils/saveProject';
import { generateReport } from './utils/generateReport';

export default function App() {
  const fileInputRef = useRef(null);

  const [projectInfo, setProjectInfo] = useState({
    assessor:      '',
    projectName:   '',
    projectType:   '',
    dateTime:      new Date().toISOString().slice(0, 10),
    propertyPhoto: null,
  });
  const [rooms, setRooms] = useState([]);

  // Load / Save
  const openFilePicker = () => fileInputRef.current.click();
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const loaded = await loadProjectFromFile(file);
    setProjectInfo(loaded.projectInfo);
    setRooms(loaded.rooms);
    e.target.value = '';
  };
  const handleSaveClick = () => saveProjectToDisk(projectInfo, rooms);

  // Room add/update/delete
  const addRoom = () => {
    const nextId = rooms.length ? Math.max(...rooms.map(r => r.id)) + 1 : 1;
    setRooms(rs => [
      ...rs,
      {
        id: nextId,
        room: '',
        area: '',
        floor: '',
        compassDirection: '',
        observations: '',
        observationsPhotos: [],
        labResults: [],
        iaqReadings: null,
        recommendations: '',
        requirements: { requirement: '', approxFt: '' },
      },
    ]);
  };
  const updateRoom = (id, patch) =>
    setRooms(rs => rs.map(r => r.id === id ? { ...r, ...patch } : r));
  const deleteRoom = (id) =>
    setRooms(rs => rs.filter(r => r.id !== id));

  return (
    <div className="p-6 max-w-3xl mx-auto">
      {/* Hidden loader */}
      <input
        ref={fileInputRef}
        type="file"
        className="hidden"
        accept=".gz"
        onChange={handleFileChange}
      />

      {/* Project controls */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Project Setup</h1>
        <div className="flex gap-2">
          <button
            className="bg-gray-600 text-white px-3 py-1 rounded"
            onClick={openFilePicker}
          >
            Load Project
          </button>
          <button
            className="bg-blue-600 text-white px-3 py-1 rounded"
            onClick={handleSaveClick}
          >
            Save Project
          </button>
        </div>
      </div>

      {/* Forms */}
      <ProjectIntro
        data={projectInfo}
        onChange={(f, v) => setProjectInfo(p => ({ ...p, [f]: v }))}
      />
      {rooms.map(r => (
        <RoomForm
          key={r.id}
          roomData={r}
          onDataChange={updateRoom}
          onDeleteRoom={() => deleteRoom(r.id)}
        />
      ))}

      {/* Action buttons */}
      <div className="mt-6 flex gap-4">
        <button
          className="bg-green-600 text-white px-4 py-2 rounded"
          onClick={addRoom}
        >
          Add Room
        </button>
        <button
          className="bg-indigo-600 text-white px-4 py-2 rounded"
          onClick={() => generateReport(projectInfo, rooms)}
          disabled={!rooms.length}
        >
          Generate Word Report
        </button>
      </div>
    </div>
  );
}
